import React, {Component} from 'react';
import AuthConnector from '../../containers/auth_container';
import {Button, Form, Grid, Image, Message, Segment, Header, Popup} from "semantic-ui-react";
import {updatePassword} from "../../data/user_api";
import validatePasswordStrength from "../../utils/password_validation";

class ChangePassword extends Component {

    constructor(props){
        super(props);
        this.state = {
            showError:false,
            message:undefined,
            success:undefined,
            passwordMatch:undefined
        }
    }

    validatePassword = (password) => {
        this.setState({
            pswdLength:validatePasswordStrength.charLength(password),
            pswdLC:validatePasswordStrength.lowercase(password),
            pswdUC:validatePasswordStrength.uppercase(password),
            pswdSym:validatePasswordStrength.special(password),
            pswdNum:validatePasswordStrength.hasNumber(password),
        });
    };


    errorMessage = () => {
            return (
                <Message size='mini' negative onDismiss={() => {
                    this.setState({showError: false})
                }}>
                    <Message.Header>An Error Occured</Message.Header>
                    <p>{this.state.message}</p>
                </Message>
            );
        };

    successMessage = () => {
        return (
            <Message size='mini' success>
                <Message.Header>Password Changed Successfully!!</Message.Header>
                {!this.props.userId && <p>You'll have to sign-in Again. You'll be redirected to sign-in page shortly</p>}
            </Message> )
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        updatePassword(formData).then((response)=>{
            if(response.success){
                this.setState({success:true,showError:false});
                { !this.props.userId && setTimeout(() => { this.props.signOutAction() }, 3000) };
            }
            else {
                this.setState({success:false,showError:true,message:response.error});
            }
        })
    };

    render(){
        const user = JSON.parse(localStorage.getItem('user'));
        return(
            <div className="login-form">
                <Grid textAlign='center' style={{height: '100%'}}>
                    <Grid.Column style={{maxWidth: 450}}>
                        {this.state.success && this.successMessage()}
                        {this.state.showError && this.errorMessage()}
                        {!this.state.success && <Form onSubmit={this.handleSubmit}>
                            <Segment>
                                {this.state.errorMessage && this.errorMessage()}
                                <Header content="Update Password" textAlign="center" />
                                <input type="hidden" name="user_id" value={this.props.userId? this.props.userId : user['user_id']} />
                                {!this.props.userId && <Form.Input fluid icon='lock' iconPosition='left' placeholder='Current Password'
                                    name="current_password" type="password" required />}
                                <Popup trigger={
                                    <Form.Input fluid icon='lock' iconPosition='left'
                                                placeholder='New Password'
                                                type='password' name="new_password" pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[\W])(?=.*\d).{6,}"
                                                onChange={(e) => {this.validatePassword(e.target.value); this.setState({password:e.target.value})}}
                                                required/>}
                                       content={<Segment>
                                           <p className={this.state.pswdLength?"info-success":"info-negative"}>Password must be 6 chars or more</p>
                                           <p className={this.state.pswdLC?"info-success":"info-negative"}>Must have atleast 1 lowercase</p>
                                           <p className={this.state.pswdUC?"info-success":"info-negative"}>Must have atleast 1 uppercase</p>
                                           <p className={this.state.pswdSym?"info-success":"info-negative"}>Must have atleast 1 special character</p>
                                           <p className={this.state.pswdNum?"info-success":"info-negative"}>Must have atleast 1 Number</p>
                                       </Segment>}
                                       on="focus"
                                       position="right center"
                                       wide
                                       hideOnScroll
                                />
                                {this.state.passwordMatch === false && <p style={{textAlign:'right',color:'red'}}>Password doesn't match</p>}
                                <Form.Input fluid icon='lock' iconPosition='left' placeholder='Re-Enter New Password'
                                            type='password'  name="password_confirmation"
                                            required
                                            onChange={(e) => {this.setState({passwordMatch:(this.state.password === e.target.value)})}}
                                />
                                <Button primary fluid size='large'>Change Password</Button>
                            </Segment>
                        </Form>}
                    </Grid.Column>
                </Grid>
            </div>
        )
    }
}

export default AuthConnector(ChangePassword);


// WEBPACK FOOTER //
// ./src/views/auth/change_password.js